
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4677_3794)"}},[_c('path',{attrs:{"d":"M6 2l11.25 6.5-3.75 3L6 8V2zm0 7l3.5 2.25L6 22 18 9v6L6 22V9z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M23 17l-6 6M17 17l6 6","stroke":"#f15757","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4677_3794"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    